<template>
  <div>
    <input v-model="searchTerm" placeholder="Search entries..." @input="filterEntries">
  </div>
</template>

<script>
export default {
  props: ['entries'],
  data() {
    return {
      searchTerm: ''
    };
  },
  methods: {
    filterEntries() {
      if (this.searchTerm) {
        const filtered = this.entries.filter(entry =>
            entry.title.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
            entry.content.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
        this.$emit('filtered', filtered);
      } else {
        this.$emit('filtered', this.entries); // Emit all entries if search term is cleared
      }
    }
  }
};
</script>

